export default __webpack_public_path__ + "static/media/app7-wave-bg.29ceb44a.png";